<template>
  <div>
    <vue-loading :loading="isLoading"></vue-loading>
    <vue-modal-custom v-model="modal.visible"
      :header="false"
      :backdrop="false"
      :keyboard="false"
      :footer="false"
      :modalBodyClass="$prefixClass.modal + `-promotion-code`">
      <div class="promotion-code">
        <img class="m-b-12" src="../assets/icons/check-code.svg" />
        <div class="promotion-code__header">
          <h3 class="m-b-8">{{$t('promotion.title')}}</h3>
          <p class="m-0 text-color-secondary" v-html="$t('promotion.description')"></p>
        </div>
        <div class="promotion-code__input-group m-t-16">
          <div :class="['voucher-input-wrapper', $prefixClass.row, $prefixClass.form + '-item', voucher.formstate && !$v.voucher.code.valid && !voucher.isChecking ? 'has-rrror' : '']">
            <div
              :class="[$prefixClass.col + '-17 p-r-12', voucher.formstate && !voucher.isChecking && (!$v.voucher.code.required || !$v.voucher.code.valid) ? 'has-error': '']">
              <a-input :placeholder="$t('promotion.input_placeholder')" v-model="voucher.code"
                @change="onChangeCode">
                <template slot="suffix">
                  <i :class="['fas fa-times', {'visible': !$v.voucher.code.valid && voucher.code}]"
                    @click="clearVoucherCode"></i>
                  <i v-if="voucher.isChecking"
                    :class="['fas fa-circle-notch m-l-30', {'fa-pulse': voucher.isChecking}]"></i>
                  <template v-else-if="voucher.formstate">
                    <i v-if="$v.voucher.code.valid" class="fas fa-check m-l-30"></i>
                    <i v-else class="fas fa-exclamation m-l-30"></i>
                  </template>
                </template>
              </a-input>
            </div>
            <div :class="$prefixClass.col + '-7'">
              <a-button  type="primary" :disabled="!$v.voucher.code.valid || isLoading"
                @click="applyVoucher(false)">
                {{$t('promotion.buttons.redeem_now')}}
              </a-button>
            </div>
          </div>
          <div v-if="voucher.formstate" :class="[$prefixClass.row, 'voucher-errors-wrapper']">
            <div :class="$prefixClass.col + '-17'">
              <transition name="fade-in" mode="out-in">
                <div v-if="!$v.voucher.code.required && !voucher.isChecking" class="form-error">
                  {{ $t('errors.required_field') }}
                </div>
                <div v-else-if="!$v.voucher.code.valid && !voucher.isChecking" class="form-error">
                  {{ $t("promotion.errors.code_invalid") }}
                </div>
              </transition>
            </div>
            <label :class="$prefixClass.col + '-7'"></label>
          </div>
        </div>
      </div>
    </vue-modal-custom>
    <modal-free-used-promotion v-model="modalFreeUsedPromotion" @upgrade="applyVoucher(true)"></modal-free-used-promotion>
    <modal-extended-success v-model="modalExtendedSuccess"></modal-extended-success>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from "vuex";
import { types as typesPromotions } from '../constant'
import { types as typesAuth } from '@/modules/auth/constant'
import { types as typesCharge } from '@/modules/charge/constant'
import { FREE_PLAN, PREMIUM_PLAN } from '@/constants/plans'
import ModalFreeUsedPromotion from "./ModalFreeUsedPromotion"
import ModalExtendedSuccess from "./ModalExtendedSuccess"
export default {
  name: 'ModalPromotionCode',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  validations: () => ({
    voucher: {
      code: {
        required,
        valid: function (value) {
          return this.voucher.isValid
        }
      }
    },
  }),
  components: {
    ModalFreeUsedPromotion,
    ModalExtendedSuccess
  },
  data() {
    return {
      isLoading: false,
      modalFreeUsedPromotion: {
        visible: false,
        charging: false
      },
      modalExtendedSuccess: {
        visible: false
      },
      voucher: {
        timer: null,
        isValid: false,
        msgError: '',
        code: '',
        isChecking: false,
        formstate: false
      }
    }
  },
  computed: {
    ...mapGetters({
      store: typesAuth.getters.GET_STORE
    }),
    modal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    isFree() {
      return this.store && this.store.app_plan == FREE_PLAN
    }
  },
  watch: {
    modal: {
      handler(value) {
        if (value.visible) {
          this.resetVoucher()
        }
        if (value.chargeSuccess) {
          this.modalExtendedSuccess.visible = true
        }
      },
      deep: true
    },
    isLoading: {
      handler(value) {
        this.modalFreeUsedPromotion.charging = value
      }
    },
    modalFreeUsedPromotion: {
      handler(value) {
        this.modal.freeUsedVisible = value.visible
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      checkCode: typesPromotions.actions.CHECK_ONECOMMERCES_CODE,
      handleChargePlan: typesCharge.actions.HANDLE_CHARGE_PLAN
    }),
    resetVoucher() {
      this.voucher.timer = null
      this.voucher.isValid = false
      this.voucher.msgError = ''
      this.voucher.code = ''
      this.voucher.isChecking = false
      this.voucher.formstate = false
    },
    applyVoucher(freeChecked=false) {
      if (this.isFree && !freeChecked) {
        this.modal.visible = false
        this.modalFreeUsedPromotion.visible = true
        return;
      }
      let data = {
        name: this.isFree ? PREMIUM_PLAN : this.store.app_plan,
        discountCode: this.voucher.code
      }
      this.onChargePlan(data)
    },
    clearVoucherCode() {
      this.voucher.code = ''
      this.voucher.formstate = false
    },
    onChangeCode() {
      this.voucher.isValid = false
      this.voucher.formstate = true
      this.onEnterCodeDiscount()
    },
    onEnterCodeDiscount() {
      clearTimeout(this.voucher.timer)
      this.voucher.isChecking = true
      this.voucher.timer = setTimeout(() => {
        if (this.voucher.code.toUpperCase() != 'ONECOMMERCE') {
          this.voucher.isValid = false
          this.voucher.msgError = this.$t("promotion.errors.code_invalid")
          this.voucher.formstate = true
          this.voucher.isChecking = false
          return;
        }
        this.checkCode({
          code: this.voucher.code
        }).then(res => {
          let {
            status,
            data,
            message
          } = res.data
          if (status) {
            this.voucher.isValid = true
            this.voucher.msgError = ''
          } else {
            this.voucher.isValid = false
            this.voucher.msgError = message
          }
          this.voucher.formstate = true
          this.voucher.isChecking = false
        })
      }, 300)
    },
    async onChargePlan({name, discountCode = ''}){
      this.isLoading = true
      let self = this
      await this.handleChargePlan({plan: name, discount_code: discountCode, used_trial: self.store.used_trial, onecommerce_promo: true}).then(async res => {
        let { status, data } = res.data
        if( status ){
          window.location.href = data.redirect_url
        }
        self.modal.visible = false
        self.isLoading = false
      })
    }
  }
}
</script>
<style lang="scss">
.#{$modal}-promotion-code {
  width: 616px !important;
  .#{$modal} {
    &-content {
      background-size: cover;
      background-position: bottom;
      background-image: url('../assets/images/promotion-bg.svg');
    }

    &-close {
      color: $text-color-secondary !important;
    }

    &-body {
      padding: 28px 74px;
      text-align: center;
      height: 383px;

      .promotion-code {
        &__input-group {
          text-align: left;

          .#{$btn}-primary {
            height: 40px;
          }

          .voucher-input-wrapper {
            margin-bottom: 0;
            display: flex;
            align-items: center;

            .fa-times {
              &:hover {
                cursor: pointer;
              }
            }

            .fa-times,
            .fa-circle-notch {
              font-weight: 300;
            }

            .fa-exclamation {
              color: $danger-color;
            }

            .fa-check {
              font-weight: normal;
              color: $success-color;
            }
          }

          .voucher-errors-wrapper {
            .form-error {
              margin-top: 4px;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

</style>